import type { QueryClient } from "@tanstack/react-query";

export const CAIXAS_KEY = ["caixas"];
export const CAIXAS_SUPPLIER_SUMMARIES_KEY = [
  ...CAIXAS_KEY,
  "supplier-summaries",
];
export const SUPPLIERS_QUERY_KEY = ["suppliers"];
export const SUPPLIER_REPORT_STATUSES_KEY = ["suppliers", "report-statuses"];
export const SUPPLIER_CAIXAS_KEY = ["supplierCaixas"];

type QueryInvalidator = Pick<QueryClient, "invalidateQueries">;

export function invalidateCaixaQueries(qc: QueryInvalidator) {
  qc.invalidateQueries({ queryKey: CAIXAS_KEY });
  qc.invalidateQueries({ queryKey: SUPPLIER_CAIXAS_KEY });
  qc.invalidateQueries({ queryKey: SUPPLIERS_QUERY_KEY, exact: true });
  qc.invalidateQueries({ queryKey: SUPPLIER_REPORT_STATUSES_KEY });
}
